import { useEffect, useState } from 'react'
import { useAuthStore } from '@stores/auth'
import { authService } from '@services/auth.service'

/**
 * Hook to validate authentication state on app load
 * Ensures localStorage auth state matches server session
 */
export function useAuthValidation() {
  const [isValidating, setIsValidating] = useState(true)
  const { isAuthenticated, login, logout } = useAuthStore()

  useEffect(() => {
    const validateSession = async () => {
      // If not authenticated in store, nothing to validate
      if (!isAuthenticated) {
        setIsValidating(false)
        return
      }

      try {
        // Verify the session is still valid by fetching profile
        const user = await authService.getProfile()
        // Update the store with fresh user data
        login(user)
      } catch {
        // Session invalid - clear the store
        logout()
      } finally {
        setIsValidating(false)
      }
    }

    validateSession()
  }, []) // Run once on mount

  return { isValidating }
}
